<template>
  <div data-app>
    <v-sheet outlined>
    <v-data-table
      :headers="request == 'ContractorRecognition'?contracterRecognitionItemHeader : itemsTableFields"
      :items="tradeRequestItems"
      tableClasses="item-table border"
      responsive
      disable-pagination
      hide-default-footer
      fixed-header
      ref="baseTable"
      :expanded.sync="expanded"
      :single-expand="true"
      item-key="id"
    >
    <template v-slot:[`item.responseDocumentCount`]="{ item }">
        {{item && item.responseDocuments ?item.responseDocuments.length:'' }}
      </template>
      <template v-slot:[`item.documentCount`]="{ item }">
        {{ item && item.documents ?item.documents.length:'' }}
      </template>
      <template v-slot:[`item.deliveryType`]="{ item }">
        {{ DeliveryDurationDisplayName(item.deliveryType) }}
      </template>
      <template v-slot:[`item.deliveryLocation`]="{ item }">
        {{ DeliveryLocationDisplayName(item.deliveryLocation) }}
      </template>
       <template v-slot:[`item.quantity`]="{ item }">
        {{ String(item.quantity) | priceSplitter }}
        {{item.measurementUnitTitle ?item.measurementUnitTitle : '' }}
      </template>
      <template v-slot:[`item.requireDateUtc`]="{ item }">
        {{ jalaliDate(item.requireDateUtc) }}
      </template>
      <template v-slot:[`item.technicalHelpNeeded`]="{ item }">
        {{ item.technicalHelpNeeded ? 'بله' : 'خیر' }}
      </template>
      <template v-slot:[`item.dataTableExpand`]="item">      
          <v-btn
            icon
            title="مشاهده اطلاعات "
            :color="indexExpanded[item.index] > -1 ? 'primary' : 'error'"
            @click="clickColumn(item)"
          >
            <v-icon> mdi-file-document </v-icon>
          </v-btn>
          <span>{{indexExpanded[item.index] > -1 ? 'مشاهده' : 'بستن'}}</span>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <v-sheet outlined class="my-4 pa-5">
            <div class="d-flex  justify-center mb-4">
              <strong >گزارش تعدادی برگزاری مناقصه/استعلام</strong>
            </div>
            <v-divider></v-divider>
            <v-row v-if="contributersInfoItem && contributersInfoItem[item.index][0] ">
           
             <v-col cols="12" md="3">
              <label>واجدین شرایط:</label>
              <strong>{{ contributersInfoItem[item.index][0] &&  contributersInfoItem[item.index][0].totalMerchantsCount>=0 ? contributersInfoItem[item.index][0].totalMerchantsCount :'' }}</strong>
            </v-col>
             <v-col cols="12" md="3">
              <label>
                  تمایل به ارائه پیشنهاد :
              </label>
              <strong>{{contributersInfoItem[item.index][0] && contributersInfoItem[item.index][0].merchantsAcceptCount>=0 ? contributersInfoItem[item.index][0].merchantsAcceptCount  :''}}</strong>
            </v-col>
             <v-col cols="12" md="3">
              <label>
                  عدم تمایل به ارائه پیشنهاد :
                </label>
              <strong>{{contributersInfoItem[item.index][0] && contributersInfoItem[item.index][0].merchantsRejectCount >=0? contributersInfoItem[item.index][0].merchantsRejectCount :'' }}</strong>
            </v-col>
            <v-col cols="12" md="3">
              <label>
                  مشاهده شده :
                </label>
              <strong>{{  contributersInfoItem[item.index][0] && contributersInfoItem[item.index][0].merchantsReadCount >=0?  contributersInfoItem[item.index][0].merchantsReadCount :''}}</strong>
            </v-col>
            <v-col cols="12" md="3">
              <label>
                  مشاهده نکرده اند :
                </label>
              <strong>{{  contributersInfoItem[item.index][0] && contributersInfoItem[item.index][0].merchantsUnreadCount>=0? contributersInfoItem[item.index][0].merchantsUnreadCount :'' }}</strong>
            </v-col>
            <v-col cols="12" md="3">
              <label> کل پاسخ ها:</label>
              <strong>{{ contributersInfoItem[item.index][0] &&  contributersInfoItem[item.index][0].totalResponsesCount>=0 ? contributersInfoItem[item.index][0].totalResponsesCount :''}}</strong>
            </v-col>
            <v-col cols="12" md="3">
              <label> پاسخ های پیش نویس:</label>
              <strong>{{  contributersInfoItem[item.index][0] &&  contributersInfoItem[item.index][0].draftResponsesCount>=0 ?  contributersInfoItem[item.index][0].draftResponsesCount:'' }}</strong>
            </v-col>
            <v-col cols="12" md="3">
              <label> پاسخ های ارسال شده :</label>
              <strong>{{ contributersInfoItem[item.index][0] && contributersInfoItem[item.index][0].sentResponsesCount>=0 ?contributersInfoItem[item.index][0].sentResponsesCount:''}}</strong>
            </v-col>
            </v-row>
          </v-sheet>
          <v-spacer />
        </td>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          v-if="!$store.getters.tradeRequestShowDetailForm"
          icon
          title="ویرایش"
          color="primary"
          :disabled="$store.getters.tradeRequestEditMode"
          @click="
            $emit('editItem', item);
            stepperProp = 2;
          "
        >
          <v-icon> mdi-pencil </v-icon>
        </v-btn>
        <v-btn
          v-if="$store.getters.tradeRequestShowDetailForm"
          small
          title="مشاهده"
          color="primary"
          @click="displayItem(item)"
        >
          مشاهده
        </v-btn>
        <v-btn
          icon
          :disabled="$store.getters.tradeRequestEditMode 
          "
          v-if="!$store.getters.tradeRequestShowDetailForm"
          title="حذف"
          color="error"
          @click="$emit('removeItem', item)"
        >

          <v-icon> mdi-delete </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    </v-sheet>
    <v-dialog
      v-model="showDialog"
      max-width="1000"
      v-if="showDialog && selectedItem && Object.keys(selectedItem).length"
    >
      <v-card>
        <v-card-title > {{request != 'ContractorRecognition'?'مشاهده جزییات قلم سفارش' : 'مشاهده جزییات سفارش'}}  
           <v-spacer/>
        <v-btn  icon color="error" @click=" 
              showDialog = false;
              selectedItem = null;
            ">
            <v-icon>mdi mdi-close</v-icon></v-btn></v-card-title>
       
        <v-divider></v-divider>
        <v-card-text class="mt-3">
          <v-row>
            <v-col cols="6" md="4" v-if="request != 'ContractorRecognition'">
              <label>نام:</label>
              <strong>{{ selectedItem.title }}</strong>
            </v-col>
            <v-col cols="6" md="4" v-if="request != 'ContractorRecognition'">
              <label>تعداد:</label>
              <strong>{{ String(selectedItem.quantity)| priceSplitter }}</strong>
            </v-col>
            <v-col cols="6" md="4" v-if="request != 'ContractorRecognition'">
              <label>واحد شمارش:</label>
              <strong>{{ selectedItem.measurementUnitTitle }}</strong>
            </v-col>
            <v-col cols="6" md="4" v-if="request != 'ContractorRecognition'">
              <label>محل تحویل:</label>
              <strong>
                {{ DeliveryLocationDisplayName(selectedItem.deliveryLocation) }}
              </strong>
            </v-col>
            <v-col cols="6" md="4" v-if="request != 'ContractorRecognition'">
              <label>تاریخ شروع تحویل دهی: </label>
              <strong>{{ jalaliDate(selectedItem.requireDateUtc) }}</strong>
            </v-col>
            <v-col cols="6" md="4" v-if="request != 'ContractorRecognition'">
              <label>روند تحویل دهی: </label>
              <strong>
                {{ DeliveryDurationDisplayName(selectedItem.deliveryType) }}
              </strong>
            </v-col>
            <v-col cols="6" md="4">
              <label> نیاز به کمک فنی دارد؟:</label>
              <strong>
                {{ selectedItem.technicalHelpNeeded ? 'بله' : 'خیر' }}
              </strong>
            </v-col>

            <v-col cols="12">
              <v-col cols="12">
                  <strong class="blue--text">مدارک مورد نیاز پاسخ </strong>
                </v-col>
              <v-sheet
                outlined
               
                v-if="selectedItem.responseDocuments && selectedItem.responseDocuments.length"
              >
                <v-data-table
                :items="selectedItem.responseDocuments"
                disable-pagination
                :headers="responseDocumentHeader"
                hide-default-footer>
                 <template v-slot:[`item.isOptional`]="{ item }">
                    {{
                     item.isOptional
                      ?  "اختیاری":'اجباری'
                    }}
                  </template>
                </v-data-table>
              </v-sheet>
            </v-col>
            <v-col cols="12">
              <v-sheet
                outlined
                class="pa-1 pa-6 mt-5"
                v-if="selectedItem.documents && selectedItem.documents.length"
              >
                <v-col cols="12">
                  <strong class="blue--text">فایل اطلاعات پیوست </strong>
                </v-col>
                <v-row>
                  <v-col
                   cols="12"
                    sm="4"
                    md="3"
                    v-for="(x, i) in selectedItem.documents"
                    :key="i"
                  >
                    <v-card height="320">
                      <v-card-text>
                        <v-col cols="12">
                          <v-img
                            v-if="x.fileId && x.fileId.thumbnailFileUrl"
                            :src="x.fileId.thumbnailFileUrl"
                            max-height="120px"
                          />
                        </v-col>
                        <v-col cols="12">
                          <label> نوع فایل:</label>
                          <strong>{{ x.documentTypeTitle }}</strong>
                        </v-col>
                        <v-col cols="12">
                          <label> توضیحات:</label>
                          <strong>{{
                            x.description ? x.description : 'وارد نشده'
                          }}</strong>
                        </v-col>
                        <v-col cols="12">
                          <a target="_blank" :href="x.fileId && x.fileId.fileUrl? x.fileId.fileUrl: ''">{{
                            x.fileId && x.fileId.fileUrl ? 'دانلود' : ''
                          }}</a>
                        </v-col>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-col>
            <v-col cols="12">
              <v-sheet
                outlined
                class="pa-1 pa-6 mt-5"
                v-if="selectedItem.techInfos && selectedItem.techInfos.length"
              >
                <v-col cols="12">
                  <strong
                    class="blue--text"
                    v-if="
                      selectedItem.techInfos.length &&
                      selectedItem.techInfos[0]
                        .tradeRequestItemPropertyValues &&
                      selectedItem.techInfos[0].tradeRequestItemPropertyValues
                        .length == 0
                    "
                  >
                    نوع فرآیند
                  </strong>
                  <strong
                    class="blue--text"
                    v-else-if="
                      selectedItem.techInfos.length &&
                      selectedItem.techInfos[0]
                        .tradeRequestItemPropertyValues &&
                      selectedItem.techInfos[0].tradeRequestItemPropertyValues
                        .length > 0
                    "
                    >
                    مشخصات 
                  {{selectedItem.techInfos[0].productCategoryName}}
                    </strong
                  >
                </v-col>
                <v-row class="mt-3">
                  <v-col
                    cols="12"
                    v-if="
                      selectedItem.techInfos.length &&
                      selectedItem.techInfos[0]
                        .tradeRequestItemPropertyValues &&
                      selectedItem.techInfos[0].tradeRequestItemPropertyValues
                        .length == 0 &&
                      !techInfoEditMode
                    "
                  >
                    <TradeRequestInformationTable
                      :items="selectedItem.techInfos"
                      :fields="tradeRequestInformationFields"
                    />
                  </v-col>

                  <v-card
                    width="100%"
                    class="pa-5"
                    v-else-if="
                      selectedItem.techInfos.length &&
                      selectedItem.techInfos[0]
                        .tradeRequestItemPropertyValues &&
                      selectedItem.techInfos[0].tradeRequestItemPropertyValues
                        .length > 0 &&
                      !techInfoEditMode
                    "
                  >

                <!-- <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    v-for="(
                      property, index
                    ) in selectedItem.techInfos[0]
                        .tradeRequestItemPropertyValues"
                    :key="index"
                  > -->
                   <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        v-for="(property, index) in selectedItem.techInfos[0]
                          .tradeRequestItemPropertyValues"
                        :key="index"
                      >
                        <v-row>
                          <v-col cols="12" sm="4">
                            <label
                              >{{ property.categoryPropertyTitle }} :
                            </label></v-col
                          >

                          <v-col cols="12" sm="8">
                            <strong
                              v-if="property.propertyType == 'MultiSelectList'"
                            >
                              <label
                                v-for="(prop, index) in property.value.split(
                                  '|'
                                )"
                                :key="index"
                              >
                                {{ prop.replaceAll("null", "") }}
                                <label
                                  v-if="
                                    index <
                                      property.value.split('|').length - 1 &&
                                    prop
                                  "
                                >
                                  -
                                </label>
                              </label>
                            </strong>
                            <strong v-else-if="property.propertyType == 'Logical'">
                              {{
                                property.value ==true ? 'بله' : 'خیر'
                              }}
                            </strong>
                            <strong v-else
                              >{{
                                property.maxValue
                                  ? `از ${property.value} تا ${property.maxValue}`
                                  : property.value
                              }}
                              {{ property.measurementUnitDisplayText }}</strong
                            >
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                

                  </v-card>
                  <v-card
                    width="100%"
                    class="pa-5"
                    v-else-if="techInfoEditMode"
                  >
                    <v-col cols="12">
                      <TradeRequestInformationTreeSelect
                        :techInfos="techInfoProps"
                        :setTechInfo="setTechInfo"
                        @getCategoriesList="getCategoriesList"
                        @getTradeRequestItemPropertyValues="
                          getTradeRequestItemPropertyValues
                        "
                      >
                      </TradeRequestInformationTreeSelect>
                    </v-col>
                  </v-card>
                  <v-col cols="12" class="float-right text-right">
                    <v-btn
                      @click="submitTechInfo"
                      small
                      color="primary"
                      v-if="
                        techInfoEditMode && selectedItem.category != 'Product'
                      "
                      >ثبت
                    </v-btn>
                    <v-btn
                      @click="enableTechInfoEditMode"
                      small
                      color="primary"
                      v-if="
                        (!techInfoEditMode &&
                          tradeRequest.requestStatus == 'Draft') ||
                        tradeRequest.requestStatus == 'Rejected'
                      "
                      >ویرایش
                    </v-btn>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            @click="
              showDialog = false;
              selectedItem = null;
            "
          >
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { RepoFactory } from '@/baseRepository/Factory';
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import reusableMethodsMixin from '@/core/mixins/reusableMethodsMixin';
import { GET_ENUMS } from '../../enums/store/types';
import TradeRequestInformationTable from './TradeRequestInformationTable';
import TradeRequestInformationTreeSelect from './TradeRequestInformationTreeSelect';
const tradeRequestRepository = () => RepoFactory.get('tradeRequests');
import Helper from '@/core/helpers';

export default {
  mixins: [asyncLoadMixin, reusableMethodsMixin],
  components: {
    TradeRequestInformationTable,
    TradeRequestInformationTreeSelect,
  },
  props: {
    tradeRequestItems: Array,
    stepper: Number,
    request: String
  },
  data() {
    return {
       responseDocumentHeader:[
        {
          value: 'isOptional',
          text: 'اختیار الصاق',
          sortable: true,
        },
        {
          value: 'documentTypeTitle',
          text: 'عنوان اصلی ',
          sortable: true,
        },
         {
          value: 'subTitle',
          text: 'عنوان دلخواه',
          sortable: true,
        },

        ],
      contributersInfoHeader:[
         {
          value: 'title',
          text: 'نام',
          sortable: true,
        },
        {
          value: 'number',
          text: 'تعداد',
          sortable: true,
        },
      ],
      contributersInfoItem:null,
      expanded: [],
      indexExpanded: [],
      id: null,
      tradeRequest: [],
      setTechInfo: false,
      techInfoProps: [],
      techInfos: null,
      techInfoEditMode: false,
      deliveryDurationTypeList: [],
      deliveryLocationList: [],
      selectedItem: null,
      showDialog: false,
      
      tradeRequestInformationFields: [
        {
          value: 'productCategoryName',
          text: 'نام فعالیت',
          sortable: false,
        },
        {
          value: 'processType',
          text: 'نوع فرآیند',
          sortable: false,
        },
        {
          value: 'breadcrumb.breadcrumb',
          text: 'فرایند اصلی',
          sortable: false,
        },
      ],
      tradeRequestInformationProductFields: [
        {
          value: 'productCategoryName',
          text: 'نام فعالیت',
          sortable: false,
        },
        {
          value: 'processType',
          text: 'نوع فرآیند',
          sortable: false,
        },
        {
          value: 'breadcrumb.breadcrumb',
          text: 'فرایند اصلی',
          sortable: false,
        },
      ],
    };
  },
  computed: {
    contracterRecognitionItemHeader(){
      
      let header =[
        {
          value: 'responseDocumentCount',
          text: 'تعداد مدارک پاسخ',
          sortable: false,
        },
        {
          value: 'documentCount',
          text:'تعداد مدارک ضمیمه',
          sortable: false,
        },
        {
          value: 'technicalHelpNeeded',
          text: 'نیاز به کمک فنی',
          sortable: false,
        },
         this.$store.getters.tradeRequestShowDetailForm && this.tradeRequest && this.tradeRequest.requestStatus == 'Published'?{
          value: 'dataTableExpand',
          text: 'اطلاعات شرکت کنندگان',
          sortable: false,
        }: {sortable: false},
        {
          value: 'actions',
          text: 'اقدام',
          sortable: false,
        },
      ]
      return header
    },
    itemsTableFields(){
       const header=
      [
        {
          value: 'title',
          text: 'موضوع',
          sortable: true,
        },

        {
          value: 'quantity',
          text: 'تعداد کالا',
          sortable: true,
        },
        {
          value: 'deliveryType',
          text: 'روند تحویل',
          sortable: true,
        },
        {
          value: 'deliveryLocation',
          text: 'محل تحویل',
          sortable: true,
        },
        {
          value: 'technicalHelpNeeded',
          text: 'نیاز به کمک فنی',
          sortable: false,
        },
        this.$store.getters.tradeRequestShowDetailForm && this.tradeRequest && this.tradeRequest.requestStatus == 'Published'?{
          value: 'dataTableExpand',
          text: 'اطلاعات شرکت کنندگان',
          sortable: false,
        }: {sortable: false},
        {
          value: 'actions',
          text: 'اقدام',
          sortable: false,
        },
      ]
      return header
    },
     
    baseUrl() {
      return this.$store.getters.tradeBaseUrl;
    },
    stepperProp: {
      get() {
        return this.stepper;
      },
      set(val) {
        this.$emit('changeStepper', val);
      },
    },
    currentMerchant() {
      return this.$store.getters.currentMerchant;
    },
  },
  watch:{
    tradeRequestItems:{
      deep :true,
      handler: function(after) {
      if (after && after.length > 0){
        if(this.$store.getters.tradeRequestShowDetailForm && this.tradeRequest && this.tradeRequest.requestStatus == 'Published'){
          this.contributersInfoItem = []
        }
        after.forEach((x, i)=>{
          this.indexExpanded.push('');
          x.index = i
          if(this.$store.getters.tradeRequestShowDetailForm && this.tradeRequest && this.tradeRequest.requestStatus == 'Published'){
            this.contributersInfoItem.push([])
          }
        })
      }
      }
    }
  },
  async created() {
    this.id = this.$route.params.id;
    if((this.id && this.id.length) || this.$store.getters.tradeRequestIsEdit){
    const loader = this.$loading.show();
    tradeRequestRepository()
      .getTradeRequestById(this.id, this.baseUrl)
      .then((res) => {
        this.tradeRequest = res.data;
      })
      .catch((err) => {
        Helper.handleErrors(err, this);
      })
      .finally(() => loader.hide());
      }
    if (!this.$store.getters.allEnums.length) {
      await this.$store.dispatch(GET_ENUMS);
    }
    this.DeliveryDurationType();
    this.DeliveryLocationType();
  },
  mounted() {},

  methods: {
    enableTechInfoEditMode() {
      this.techInfoEditMode = true;
      this.techInfoProps = this.selectedItem.techInfos;
      this.setTechInfo = true;
    },
    getTradeRequestItemPropertyValues(properties, categoryId) {
      let app = this;
      let techInfo = {
        tradeRequestItemTechInfoId: null,
        productCategoryId: null,
        processType: null,
        tradeRequestItemPropertyValues: null,
      };
      techInfo.tradeRequestItemTechInfoId = app.selectedItem.techInfos[0].id;
      techInfo.productCategoryId = categoryId[0];
      techInfo.processType = 'MainProcess';
      techInfo.tradeRequestItemPropertyValues = properties;

      this.techInfos = techInfo;
     
      let body,items=[]
      this.tradeRequest.items.forEach(item=>{
        let tradeRequestItemPropertyValues =[]
        item.techInfos[0].tradeRequestItemPropertyValues.forEach(x=>{
          tradeRequestItemPropertyValues.push({
          categoryPropertyId: x.categoryPropertyId,
          id: x.id ,
          measurementUnitId: x.measurementUnitId,
          value: x.value
          })
        })
        if(item.id != this.selectedItem.id) {
          items.push(
            {
              id: item.id,
              techInfos: [{
                tradeRequestItemTechInfoId :
                item.techInfos[0] && item.techInfos[0].id
                  ? item.techInfos[0].id
                  : null ,
                productCategoryId : item.techInfos[0].productCategoryId,
                processType : 'MainProcess',
                tradeRequestItemPropertyValues : tradeRequestItemPropertyValues,
              }],

            })
        }
        else{
          items.push({
             id: this.selectedItem.id,
             techInfos: [this.techInfos],
          })
        }
      })
      body = {
        items: items
      };
      this.editTechInfo(body);
    },

    getCategoriesList(list) {
      if (this.$store.getters.tradeRequestCategoryType != 'Product') {
        let techInfo = [];
        this.categoriesList = list;
        this.categoriesList.forEach((x) => {
          techInfo.push({
            tradeRequestItemTechInfoId: x.techInfoId
              ? x.techInfoId
              : x.id
              ? x.id
              : null,
            processType:
              x.productionProcessType == 'MainProcess'
                ? 'MainProcess'
                : 'SubProcess',
            productCategoryId: x.productCategoryId
              ? x.productCategoryId
              : x.categoryId
              ? x.categoryId
              : null,
            tradeRequestItemPropertyValues: null,
          });
        });
        this.techInfos = techInfo;
      }
    },
    submitTechInfo() {
      let body,items=[]
      this.tradeRequest.items.forEach(item=>{
        if(item.id != this.selectedItem.id) {
          items.push(
            {
              id: item.id,
              techInfos: item.techInfos,
            })
        }
        else{
          items.push(
            {
             id: this.selectedItem.id,
            techInfos: this.techInfos,
            })
        }
      })
      body = {
        items: items
      };
      this.editTechInfo(body);
    },
    editTechInfo(techInfo) {
      const loader = this.$loading.show();

      tradeRequestRepository()
        .editTradeRequestTechInfo(this.id, techInfo, this.baseUrl)
        .then((res) => {
          this.$dialog.message.success(' فرآیند های منتخب با موفقیت ویرایش شد. ', {
            position: 'top-left',
          });
          this.techInfos = null;
          this.techInfoEditMode = false;
          this.showDialog = false;
          this.$emit("getDataById");
          
          // this.$router.push({path:`/trade-request-info/${this.id}`})
        })
        .catch((err) => {
          Helper.handleErrors(err, this);
        })
        .finally(() => loader.hide());
    },
    DeliveryDurationDisplayName(title) {
      if (this.deliveryDurationTypeList.length) {
        let result = this.deliveryDurationTypeList.find(
          (el) => el.title == title
        );
        if (result) return result.displayName;
      }
    },
    DeliveryLocationDisplayName(title) {
      if (this.deliveryLocationList.length) {
        let result = this.deliveryLocationList.find((el) => el.title == title);
        if (result) return result.displayName;
      }
    },
    DeliveryDurationType() {
      this.deliveryDurationTypeList = this.getEnumByTitle(
        'DeliveryDurationType'
      );
    },
    DeliveryLocationType() {
      this.deliveryLocationList = this.getEnumByTitle('DeliveryLocationType');
    },
    displayItem(item) {
      this.showDialog = true;
      this.selectedItem = item;
    },
    clickColumn(slotData) {
      const indexRow = slotData.index;
      this.indexExpanded[indexRow] = this.expanded.findIndex(
        (i) => i === slotData.item
      );
      if (this.indexExpanded[indexRow] > -1) {
        this.expanded.splice(this.indexExpanded[indexRow], 1);
      } 
      else {
        this.expanded.push(slotData.item);
        this.getContributerInfo(slotData);
      }
    },
    getContributerInfo(item){
      
      const loader = this.$loading.show();
      tradeRequestRepository()
        .getContributerInfo(this.tradeRequest.id, this.baseUrl, {merchantId : this.currentMerchant}, {itemId : item.item.id})
        .then((res) => {
          this.contributersInfoItem[item.index].push(res.data)
          loader.hide()
          
        })
        .catch((err) => {
          loader.hide()
          Helper.handleErrors(err, this);
        })
        },
    
    log(item){
      console.log(item);
    }

  },
};
</script>

<style></style>
